module.exports = __webpack_public_path__ + "static/img/blog-5.7c35547a.jpeg";